import * as tslib_1 from "tslib";
import * as React from 'react';
import { AutoSizer } from 'react-virtualized/dist/commonjs/AutoSizer';
import { List as VList } from 'react-virtualized/dist/commonjs/List';
import { CellMeasurer, CellMeasurerCache } from 'react-virtualized/dist/commonjs/CellMeasurer';
import './index.css';
export var PlateGoods = function (props) {
    var goodsColumns = props.goodsColumns, goodsData = props.goodsData, rollTotalData = props.rollTotalData, _a = props.rollTotalTitle, rollTotalTitle = _a === void 0 ? {} : _a;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'roll_plate_table' },
            React.createElement("div", { className: 'roll_plate_table_row' }, goodsColumns.map(function (item, index) {
                var noneBoder = {};
                if (index === goodsColumns.length - 1) {
                    noneBoder = {
                        borderRight: '0px',
                        flex: '1',
                    };
                }
                return (React.createElement("div", { key: index, className: 'roll_plate_total_item weight_color', style: tslib_1.__assign({}, noneBoder, { width: item.width ? item.width + 'px' : 'initial', textAlign: (item.alignText || 'left'), backgroundColor: '#F6F7F9' }) }, item.title));
            })),
            goodsData.map(function (dataItem, dataIndex) {
                var itemBackgroundColor = {};
                if (dataIndex % 2 !== 0) {
                    itemBackgroundColor = {
                        backgroundColor: '#F6F7F9'
                    };
                }
                return (React.createElement("div", { className: 'roll_plate_table_row', key: dataIndex }, goodsColumns.map(function (item, index) {
                    var noneBoder = {};
                    if (index === goodsColumns.length - 1) {
                        noneBoder = {
                            borderRight: '0px',
                            flex: '1',
                        };
                    }
                    return (React.createElement("div", { key: index, className: 'roll_plate_table_item', style: tslib_1.__assign({}, itemBackgroundColor, noneBoder, { width: item.width ? item.width + 'px' : 'initial', textAlign: (item.alignText || 'left') }) }, item.render ?
                        item.render(dataItem[item.dataIndex], dataItem, dataIndex) :
                        dataItem[item.dataIndex]));
                })));
            })),
        React.createElement("div", { className: 'roll_total_box' },
            React.createElement("div", { className: 'roll_total_row_box' },
                React.createElement("div", { className: 'roll_total_title' }, rollTotalTitle.totalNum || '合计金额(小写)'),
                React.createElement("div", { className: 'roll_total_val' }, rollTotalData.totalNum)),
            React.createElement("div", { className: 'roll_total_row_box' },
                React.createElement("div", { className: 'roll_total_title' }, rollTotalTitle.totalC || '合计金额(大写)'),
                React.createElement("div", { className: 'roll_total_val' }, rollTotalData.totalC)),
            React.createElement("div", { className: 'roll_total_row_box' },
                React.createElement("div", { className: 'roll_total_title' }, rollTotalTitle.checkCode || '校验码'),
                React.createElement("div", { className: 'roll_total_val' }, rollTotalData.checkCode)))));
};
export var PlateGoodsVirtualized = function (props) {
    var goodsColumns = props.goodsColumns, goodsData = props.goodsData, rollTotalData = props.rollTotalData, _a = props.rollTotalTitle, rollTotalTitle = _a === void 0 ? {} : _a;
    var cache = new CellMeasurerCache({ defaultHeight: 30, fixedWidth: true });
    var cellRenderer = function (_a) {
        var index = _a.index, key = _a.key, parent = _a.parent, style = _a.style;
        var itemBackgroundColor = {};
        if (index % 2 !== 0) {
            itemBackgroundColor = {
                backgroundColor: '#F6F7F9'
            };
        }
        return (React.createElement(CellMeasurer, { cache: cache, columnIndex: 0, key: key, parent: parent, rowIndex: index },
            React.createElement("div", { style: style, className: 'roll_plate_table_row' }, goodsColumns.map(function (columnsItem, columnsIndex) {
                var noneBoder = {};
                if (columnsIndex === goodsColumns.length - 1) {
                    noneBoder = {
                        borderRight: '0px',
                        flex: '1',
                    };
                }
                return (React.createElement("div", { key: columnsIndex, className: 'roll_plate_table_item', style: tslib_1.__assign({}, itemBackgroundColor, noneBoder, { width: columnsItem.width ? columnsItem.width + 'px' : 'initial', textAlign: (columnsItem.alignText || 'left') }) }, columnsItem.render ?
                    columnsItem.render(goodsData[index][columnsItem.dataIndex], goodsData[index], index) :
                    goodsData[index][columnsItem.dataIndex]));
            }))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'roll_plate_table' },
            React.createElement("div", { className: 'roll_plate_table_row' }, goodsColumns.map(function (item, index) {
                var noneBoder = {};
                if (index === goodsColumns.length - 1) {
                    noneBoder = {
                        borderRight: '0px',
                        flex: '1',
                    };
                }
                return (React.createElement("div", { key: index, className: 'roll_plate_total_item weight_color', style: tslib_1.__assign({}, noneBoder, { width: item.width ? item.width + 'px' : 'initial', textAlign: (item.alignText || 'left'), backgroundColor: '#F6F7F9' }) }, item.title));
            })),
            React.createElement("div", { style: { height: '240px' } },
                React.createElement(AutoSizer, null, function (_a) {
                    var height = _a.height, width = _a.width;
                    return (React.createElement(VList, { height: height, rowCount: goodsData.length, rowHeight: cache.rowHeight, deferredMeasurementCache: cache, rowRenderer: cellRenderer, width: width, tabIndex: 'none' }));
                }))),
        React.createElement("div", { className: 'roll_total_box' },
            React.createElement("div", { className: 'roll_total_row_box' },
                React.createElement("div", { className: 'roll_total_title' }, rollTotalTitle.totalNum || '合计金额(小写)'),
                React.createElement("div", { className: 'roll_total_val' }, rollTotalData.totalNum)),
            React.createElement("div", { className: 'roll_total_row_box' },
                React.createElement("div", { className: 'roll_total_title' }, rollTotalTitle.totalC || '合计金额(大写)'),
                React.createElement("div", { className: 'roll_total_val' }, rollTotalData.totalC)),
            React.createElement("div", { className: 'roll_total_row_box' },
                React.createElement("div", { className: 'roll_total_title' }, rollTotalTitle.checkCode || '校验码'),
                React.createElement("div", { className: 'roll_total_val' }, rollTotalData.checkCode)))));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-invoice-plate/RollTypeInvoicePlate/PlateGoods/index.js
// module id = 4233
// module chunks = 0